import { apiConfig } from '../api-config';

export const genaratePix = async (object: any, txId: string, cdTerritory: string) => {
  return apiConfig
    .post(`/api/Payment/createPix?txid=${txId}&cdTerritory=${cdTerritory}`, object)
    .then((resp) => resp.data.objectResult || [])
    .catch((err) => ({ hasErrors: true, err }));
};
